import script from "./SchoolList.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolList.vue?vue&type=script&setup=true&lang=js"

export default script